import { AccessRule } from 'types/accessRule';

function setAll(rules: AccessRule[], state: boolean): AccessRule[] {
  return rules.map(rule => ({ ...rule, active: state, access_rules: setAll(rule.access_rules, state) }));
}

// Liga/desliga a regra e, junto, todas as filhas dela (sem alterar a lista original).
export function toggleRule(rules: AccessRule[], id: number): AccessRule[] {
  return rules.map(rule =>
    rule.id === id
      ? { ...rule, active: !rule.active, access_rules: setAll(rule.access_rules, !rule.active) }
      : { ...rule, access_rules: toggleRule(rule.access_rules, id) },
  );
}

// Marca como ativas as regras (pelo nome) que o perfil já tem.
export function markActive(rules: AccessRule[], profileRules: AccessRule[]): AccessRule[] {
  return rules.map(rule => ({
    ...rule,
    active: !!profileRules.find(item => item.name === rule.name),
    access_rules: markActive(rule.access_rules, profileRules),
  }));
}

// Quantas regras estão ativas, contando a regra e todas as descendentes.
export function countRules(rules: AccessRule[]): { active: number; total: number } {
  return rules.reduce(
    (sum, rule) => {
      const children = countRules(rule.access_rules);

      return {
        active: sum.active + (rule.active ? 1 : 0) + children.active,
        total: sum.total + 1 + children.total,
      };
    },
    { active: 0, total: 0 },
  );
}

function matches(rule: AccessRule, term: string) {
  return [rule.title, rule.description, rule.name].some(text => (text || '').toLowerCase().includes(term));
}

// Mantém só as regras que combinam com a busca (ou que têm filha que combina), preservando a árvore.
export function filterRules(rules: AccessRule[], term: string): AccessRule[] {
  const search = term.trim().toLowerCase();

  if (!search) return rules;

  return rules.reduce<AccessRule[]>((found, rule) => {
    const children = filterRules(rule.access_rules, search);

    if (matches(rule, search) || children.length > 0) {
      found.push({ ...rule, access_rules: matches(rule, search) ? rule.access_rules : children });
    }

    return found;
  }, []);
}
